import { Component, ViewChild } from '@angular/core';
import { BaseComponent } from '@base/base.component';
import { CommissionType } from '@models/reports/reports';
import { Paginator, PaginatorItems, Table } from '@models/table';
import { ReportsService } from '@services/reports.service';
import { firstValueFrom, mapTo } from 'rxjs';
import { PERMITION_CONSORTIUM_REPORTS_COMISSIONS_READ, PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_EXPORT_PDF, PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_EXPORT_XLSX, PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_READ, PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_EXPORT_PDF, PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_EXPORT_XLSX } from 'src/app/const/permitions';
import { CommissionsReportFilterComponent } from './commissions-report-filter/commissions-report-filter.component';
import { DetailViewerModalComponent } from './detail-viewer-modal/detail-viewer-modal.component';
import { FILTER_CONVERSION_BONUS, REPORT_CONVERSION_BONUS } from 'src/app/const/reports-table/report-conversion-bonus';
import { CommissionEnum, mapToReportFilename } from '@enums/commission';
import { FILTER_PAID_COMMISSIONS, REPORT_PAID_COMMISSIONS } from 'src/app/const/reports-table/report-paid-commissions';
import { FILTER_FUTURE_COMMISSION, REPORT_FUTURE_COMMISSIONS } from 'src/app/const/reports-table/report-future-comission';
import { FILTER_WITHHELD_COMMISIONS, REPORT_WITHELD_COMMISSIONS } from 'src/app/const/reports-table/report-withheld-commissions';
import { FILTER_PENDING_INVOICE, REPORT_PENDING_INVOICE } from 'src/app/const/reports-table/report-pending-invoice';

interface KeyValueComissionTable {
  [key: string]: Partial<Table<any>>;
}

const COMISSION_TABLE_CONFIG: KeyValueComissionTable = {
  // [ComissionEnum.DEFAULT]: REPORT_DEFAULT,
  [CommissionEnum.PENDING_INVOICE]: REPORT_PENDING_INVOICE,
  [CommissionEnum.PAID_COMMISSIONS]: REPORT_PAID_COMMISSIONS,//ajustar
  [CommissionEnum.WITHHELD_COMMISSIONS]: REPORT_WITHELD_COMMISSIONS,//ajustar
  [CommissionEnum.FUTURE_COMMISSION]: REPORT_FUTURE_COMMISSIONS,//ajustar
  [CommissionEnum.CONVERSION_BONUS]: REPORT_CONVERSION_BONUS,
}

const COMISSIONS: CommissionType[] = [FILTER_PENDING_INVOICE, FILTER_PAID_COMMISSIONS, FILTER_WITHHELD_COMMISIONS, FILTER_FUTURE_COMMISSION, FILTER_CONVERSION_BONUS];

@Component({
  selector: 'app-commissions-report',
  templateUrl: './commissions-report.component.html',
  styleUrl: './commissions-report.component.scss',
})
export class CommissionsReportComponent extends BaseComponent {
  @ViewChild(CommissionsReportFilterComponent) childComponent!: CommissionsReportFilterComponent;

  public isExportingExcel: boolean = false;
  public isExportingPdf: boolean = false;
  public loading: boolean = false;
  public typeCommissionIdSelected: CommissionEnum;
  public shouldQuery: boolean = false;
  public table: Table<any>;

  public allCommissions: CommissionType[] = COMISSIONS;

  public constructor(
    private readonly _reportsService: ReportsService
  ) {
    super();

    this.table = this.createTable(CommissionEnum.PENDING_INVOICE);
  }

  public get hasPermissionToExportExcel() {
    return this.getPermissions()
               .some(p => [PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_EXPORT_XLSX].includes(p));
  }

  public get hasPermissionToExportPdf() {
    return this.getPermissions()
               .some(p => [PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_EXPORT_PDF].includes(p))
  }

  public get hasPermissionToViewDetails() {
    return this.getPermissions()
               .some(p => [PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_READ].includes(p));
  }

  public get hasPermissionToExportDetailsExcel() {
    return this.getPermissions()
               .some(p => [PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_EXPORT_XLSX].includes(p));
  }

  public get hasPermissionToExportDetailsPdf() {
    return this.getPermissions()
               .some(p => [PERMITION_CONSORTIUM_REPORTS_COMMISSIONS_DETAILS_EXPORT_PDF].includes(p));
  }

  public async exportWorksheetReport(): Promise<void> {
    this.isExportingExcel = true;
    let filters = this.childComponent.form.value;

    filters.pageNumber = 1;
    filters.pageSize = this.table.paginator.length;

    try {
      const result = await firstValueFrom(this._reportsService.exportWorksheetReport(filters, this.typeCommissionIdSelected));
      this.download(result.fileBase64, result.fileName, result.contentType);
    } finally {
      this.isExportingExcel = false;
    }
  }

  public async exportPdfReport(): Promise<void> {
    this.isExportingPdf = true;
    try {
      const result = await firstValueFrom(this._reportsService.exportPdfReport(this.childComponent.form.value, this.typeCommissionIdSelected));

      this.download(result, mapToReportFilename(this.typeCommissionIdSelected), "application/pdf");
    } finally {
      this.isExportingPdf = false;
    }
  }

  public async exportWorksheetReportDetails(filters: any, pagination: Paginator): Promise<void> {
      filters.pageNumber = 1;
      filters.pageSize = pagination.length;

      const result = await firstValueFrom(this._reportsService.exportWorksheetDetailReport(filters, this.typeCommissionIdSelected));
      this.download(result.fileBase64, result.fileName, result.contentType);
  }

  public async exportPdfReportDetails(filters: any, pagination: Paginator): Promise<void> {
      filters.pageNumber = 1;
      filters.pageSize = pagination.length;

      const result = await firstValueFrom(this._reportsService.exportPdfDetailReport(filters, this.typeCommissionIdSelected));
      this.download(result, `detalhes-${mapToReportFilename(this.typeCommissionIdSelected)}`, "application/pdf");
  }

  public viewDataDetails(commission: any): void {
    let selectedCommission = this.allCommissions.find(c => c.id === this.typeCommissionIdSelected);

    let parametersDefault = {
      identifierCode: this.childComponent.form.value.identifierCode,
      startDate: new Date(commission.year, commission.month - 1, 1),
      endDate: new Date(commission.year, commission.month, 0),
      pageSize: 10,
      pageNumber: 1
    };

    const fillExtraParameters = (target: any, source: any) => {
      Object.keys(source).forEach(key => {
        if (!(key in target)) {
          target[key] = source[key];
        }
      });
    };

    fillExtraParameters(parametersDefault, commission);

    if(selectedCommission.componentModal === DetailViewerModalComponent)
    {
      const dialog = this.dialog.open(selectedCommission.componentModal, { data: {commissionConfig: selectedCommission, filters: parametersDefault, hasPermissionToExportExcel: this.hasPermissionToExportDetailsExcel, hasPermissionToExportPdf: this.hasPermissionToExportDetailsPdf  } } );
      dialog.componentInstance.onExportExcelDetail
        .subscribe(pagination => {
          dialog.componentInstance.isExportingExcelDetails = true;
          this.exportWorksheetReportDetails(parametersDefault, pagination).finally(() => dialog.componentInstance.isExportingExcelDetails = false);
        })

      dialog.componentInstance.onExportPdfDetail
            .subscribe(pagination => {
              dialog.componentInstance.isExportingPdfDetails = true;
              this.exportPdfReportDetails(parametersDefault, pagination).finally(() => dialog.componentInstance.isExportingPdfDetails = false);
            })

    } else {
      this.openDialog(selectedCommission.componentModal, { data: parametersDefault });
    }
  }

  private createTable(comission: CommissionEnum): Table<any> {

    const config = COMISSION_TABLE_CONFIG[comission];

    return {
      headers: config.headers,
      data: [],
      style: config.style,
      buttons: this.hasPermissionToViewDetails && config.buttons,
      paginator: {
        index: 1,
        itensPerPage: [10, 15, 20, 50, 100],
        pageSize: 10,
      },
      messageWithoutDates: config.messageWithoutDates,
    };
  }

  public async filter(paginator?: Paginator): Promise<void> {

    if (!paginator) {
      paginator = {
        index: 1,
        itensPerPage: [10, 15, 20, 50, 100],
        pageSize: 10,
      };
    }

    this.loading = true;

    await firstValueFrom(
      this._reportsService.getComissionReport(this.childComponent.form.value, paginator, this.typeCommissionIdSelected)
    )
      .then((resp: PaginatorItems<any>) => {
        this.table.data = resp.items;
        this.table.paginator.length = resp.totalCount;
        this.table.paginator.index = paginator.index;
        this.table.paginator.pageSize = paginator.pageSize;
      })
      .finally(() => {
        this.loading = false;
      });

  }

  public onPageChange(paginator: Paginator): void {
    this.filter(paginator);
  }

  public onTypeComissionChanged(typeCommissionId: any): void {
    this.table.data = [];
    this.typeCommissionIdSelected = typeCommissionId;
    this.table = this.createTable(this.typeCommissionIdSelected);
  }

}
